export default __webpack_public_path__ + "static/media/facility2.5aafeeed.jpg";